import { Reducer } from "react";
import { getType } from "typesafe-actions";
import { Account } from "./../../models/accounts";
import { createAccountAsync, fetchAccountsAsync } from "./actions";
import { AccountAction } from "./types";

type AccountState = {
  initialized: boolean;
  loading: boolean;
  accounts: Account[];
  creating: boolean;
  creatingError?: string;
};

const initialAccountState: AccountState = {
  initialized: false,
  loading: false,
  accounts: [],
  creating: false,
  creatingError: "",
};

const accountsReducer: Reducer<AccountState, AccountAction> = (
  state: AccountState = initialAccountState,
  action: AccountAction
) => {
  switch (action.type) {
    case getType(fetchAccountsAsync.request): {
      return { ...state, loading: true };
    }
    case getType(fetchAccountsAsync.success): {
      const accounts = action.payload.map((account) => new Account(account));
      return {
        ...state,
        loading: false,
        initialized: true,
        accounts,
      };
    }
    case getType(fetchAccountsAsync.failure): {
      return { ...state, loading: false, creatingError: action.payload };
    }

    case getType(createAccountAsync.request): {
      return { ...state, creating: true };
    }
    case getType(createAccountAsync.success): {
      const account = new Account(action.payload);
      return {
        ...state,
        creating: false,
        accounts: [...state.accounts, account],
      };
    }
    case getType(createAccountAsync.failure): {
      return { ...state, creating: false, creatingError: action.payload };
    }
    default:
      return state;
  }
};

export default accountsReducer;
